import { html, unsafeCSS, type CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { LibElement } from '../lib-element';
import css from './lib-tab.css';

/** A tab's header metadata and panel content, coordinated by its enclosing lib-tabs. */
@customElement('lib-tab')
export class LibTab extends LibElement {
  static override readonly styles: CSSResultGroup = [LibElement.hostStyles, unsafeCSS(css)];
  @property() text = '';
  @property({ attribute: 'icon-url' }) iconUrl = '';
  @property({ type: Number, attribute: 'badge-number' }) badgeNumber: number | null = null;
  @property({ type: Boolean }) disabled = false;
  @property({ type: Boolean }) invisible = false;
  @property({ type: Boolean, attribute: 'has-panel' }) hasPanel = false;

  protected override updated() { this.emit('lib-tab-update'); }

  override render() { return html`<slot></slot>`; }
}

declare global {
  interface HTMLElementTagNameMap { 'lib-tab': LibTab; }
}
